/**
 * 購入で在庫が無くなった店か（購入の個数がその店の在庫数以上）。
 * 「購入完了商品を表示する」を外した時に隠すのはこの店だけで、5 個中 3 個のように在庫が残る店は
 * チェック無しでも出す（2026-10-18 ユーザー指定）。
 * 個数の無い購入（古い記録）は 1 個として扱う。在庫数が無い・0 の店は、購入済みならこれまでどおり売り切れ扱い
 */
export function isSoldOutByPurchase(stock: {
  isPurchased: boolean;
  purchasedQuantity?: number | null;
  stockNum?: number | null;
}): boolean {
  if (!stock.isPurchased) {
    return false;
  }
  const stockNum = stock.stockNum ?? 0;
  if (stockNum <= 0) {
    return true;
  }
  return (stock.purchasedQuantity ?? 1) >= stockNum;
}
